
export const get_Random = {
                            methods: {
                                    get_Random_Nbr(){
                                                            let xx = 0 ;  
                                                                xx = Math.floor( Math.random() * ( 4 ))  + 1 ;
                                                        return xx ;
                                                        },
                                    }

}
